import BaseService from './baseService'; 



export class RealtimesService extends BaseService {
    constructor(){
        const baseUrl = "/RealTime/";
        super(baseUrl);
    }  
} 